module.exports = __webpack_public_path__ + "img/Jump Casting17.c1841e9b.jpg";